import { Controller } from "@hotwired/stimulus"

const MESSAGE_WARMED = "sm:warmed"
const PHONE_QUERY = "(max-width: 760px)"
const SLOW_CONNECTIONS = ["slow-2g", "2g", "3g"]
// Starts a moment after the page is idle, never while it is still loading, and is dropped if the frame never says it has finished.
const START_DELAY_MS = 1500
const GIVE_UP_MS = 100000
const ON_LANDING_TABS = [null, "home"]

// The home page warms the Maps tab's first example: a hidden frame loads the Maps editor's embeddable 3D page in its warm-up mode
// (`&warm=1`), which fetches the scene, the picture under the site and the models into the browser's cache without drawing anything. When the
// visitor opens the Maps tab, its frame finds all of it in the cache. It is polite about it: not on a phone (it is some twenty megabytes), not on
// a slow or data-saving connection, and not when they have landed somewhere other than the home page.
export default class extends Controller {
  static values = { url: String, origin: String }

  connect() {
    if (!this.worthDoing()) return

    this.onMessage = (event) => { if (event.origin === this.originValue && event.source === this.frame?.contentWindow && event.data.type === MESSAGE_WARMED) this.stop() }
    window.addEventListener("message", this.onMessage)
    this.onLoad = () => { this.timer = setTimeout(() => this.start(), START_DELAY_MS) }
    if (document.readyState === "complete") this.onLoad()
    else window.addEventListener("load", this.onLoad, { once: true })
  }

  disconnect() {
    this.stop()
    window.removeEventListener("load", this.onLoad)
  }

  worthDoing() {
    const connection = navigator.connection
    if (connection?.saveData || SLOW_CONNECTIONS.includes(connection?.effectiveType)) return false
    if (window.matchMedia(PHONE_QUERY).matches) return false

    return ON_LANDING_TABS.includes(new URLSearchParams(window.location.search).get("product"))
  }

  start() {
    this.frame = document.createElement("iframe")
    this.frame.src = this.urlValue
    this.frame.hidden = true
    this.frame.tabIndex = -1
    this.frame.setAttribute("aria-hidden", "true")
    this.frame.title = ""
    this.element.append(this.frame)
    this.giveUp = setTimeout(() => this.stop(), GIVE_UP_MS)
  }

  stop() {
    clearTimeout(this.timer)
    clearTimeout(this.giveUp)
    window.removeEventListener("message", this.onMessage)
    this.frame?.remove()
    this.frame = null
  }
}
